import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RefreshTokenService {

  private readonly REFRESH_URL = `${environment.auth_url}/refresh`;

  constructor(private http: HttpClient) { }

  refresh(): Observable<any> {
    const refreshToken = localStorage.getItem('refreshToken');

    return this.http.post(this.REFRESH_URL, { refreshToken }).pipe(
      tap((response: any) => {
        const newAccessToken = response.token || response.data?.token || response.accessToken;

        if (newAccessToken) {
          localStorage.setItem('token', newAccessToken);
        }

        const newRefreshToken = response.refreshToken || response.data?.refreshToken;
        if (newRefreshToken) {
          localStorage.setItem('refreshToken', newRefreshToken);
        }
      })
    );
  }
}